import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  ActionFeedbackService,
  GlobalProgressBarComponent,
} from '@arm-web/ui-components';
import { ToastContainerComponent } from './common/components/toast-container/toast-container';
import { NavigationActivityService } from './common/services/navigation-activity.service';

@Component({
  imports: [GlobalProgressBarComponent, RouterModule, ToastContainerComponent],
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App {
  private readonly navigationActivity = inject(NavigationActivityService);
  private readonly actionFeedback = inject(ActionFeedbackService);

  protected title = 'arm_web';

  constructor() {
    this.navigationActivity.track();
    this.actionFeedback.install();
  }
}
